import React from 'react'
import Page from '../components/Page'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input, Spinner } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import { MdCameraAlt, MdFace, MdDone, MdClear, MdCreate, MdAdd } from 'react-icons/md'
import { BsPlusSquareFill } from 'react-icons/bs'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import classnames from 'classnames'
//import PosShippingForm from 'components/PosShippingForm';
import { IconContext } from 'react-icons/lib'
import PosPromoTable from './PosPromoTable'
import { array } from 'prop-types'

class PosDeliveryCollectionForm extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      isEdit: false,
      id: '',
      name: '',
      company: '',
      contact: '',
      mobile: '',
      unit: '',
      postal_code: '',
      country: '',
      deliveryList: [],
      store_id: '',
    }
  }

  componentDidMount() {
    if (this.props.data.isEdit) {
      let id = this.props.data.selectedId
      const data = this.props.data.deliveryList.find(e => e.id == id)
      this.setState({
        id: id,
        name: data.pick_name,
        company: data.pick_company,
        contact: data.pick_contact,
        mobile: data.pick_mobile,
        unit: data.pick_unit,
        postal_code: data.pick_code,
        country: data.pick_country,
        isEdit: true,
      })
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  changeHandler = e => {
    let { name, value } = e.target
    this.setState({
      [name]: value,
    })
  }

  mobileHandler = e => {
    const re = /^[0-9\b]+$/
    let { name, value } = e.target
    // if value is not blank, then test the regex

    if (e.target.value === '' || re.test(e.target.value)) {
      this.setState({ [name]: value })
    }
  }

  checkHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: !this.state[name],
      free_value: !this.state[name] == true ? '0' : this.state.free_value,
    })
  }

  handleSubmit = event => {
    event.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    if (!this.state.isEdit) {
      this.create(user, comp, url)
    } else {
      this.update(user, comp, url)
    }
  }

  create(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      store_id: this.props.data.store_id,
      pick_name: this.state.name,
      pick_company: this.state.company,
      pick_contact: this.state.contact,
      pick_mobile: this.state.mobile,
      pick_unit: this.state.unit,
      pick_code: this.state.postal_code,
      pick_country: this.state.country,
      created_by: user.email,
    }

    axios
      .post(url + ':3003/v1/order/delivery/pickaddress/add', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(<MdDone />, 'New Delivery Collection added successfully.', 'success', false)
      })
      .catch(error => {
        alert(error)
      })
  }

  update(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      id: this.state.id,
      company_id: comp.CompanyID,
      store_id: this.props.data.store_id,
      pick_name: this.state.name,
      pick_company: this.state.company,
      pick_contact: this.state.contact,
      pick_mobile: this.state.mobile,
      pick_unit: this.state.unit,
      pick_code: this.state.postal_code,
      pick_country: this.state.country,
      update_by: user.email,
    }

    axios
      .post(url + ':3003/v1/order/delivery/pickaddress/update', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(
          <MdDone />,
          'Delivery Collection updated successfully.',
          'success', //'error' post when return error
          false,
        )
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>Delivery Collection</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label>Name</Label>
                <Input type="text" name="name" value={this.state.name} onChange={this.changeHandler} maxLength="35" required />
              </FormGroup>
              <FormGroup>
                <Label>Company</Label>
                <Input type="text" name="company" value={this.state.company} onChange={this.changeHandler} maxLength="30" />
              </FormGroup>
              <FormGroup>
                <Label>Contact</Label>
                <Input type="number" name="contact" value={this.state.contact} onChange={this.mobileHandler} required />
              </FormGroup>
              <FormGroup>
                <Label>Mobile</Label>
                <Input type="number" name="mobile" value={this.state.mobile} onChange={this.mobileHandler} />
              </FormGroup>
              <FormGroup>
                <Label>Unit</Label>
                <Input type="text" name="unit" value={this.state.unit} onChange={this.changeHandler} maxLength="10" required />
              </FormGroup>
              <FormGroup>
                <Label>Postal Code</Label>
                <Input type="text" name="postal_code" value={this.state.postal_code} onChange={this.changeHandler} required />
              </FormGroup>
              <FormGroup>
                <Label>Country</Label>
                <Input type="select" name="country" value={this.state.country} onChange={this.changeHandler} required>
                  <option></option>
                  <option value="SG">SG</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button className="theme-button theme-button-secondary" onClick={this.props.onToggleModal()}>
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    )
  }
}

export default PosDeliveryCollectionForm
